import React from "react";
import { useNavigate } from "react-router-dom";

import "../css/Home.css";

function ThurentServices() {
  const navigate = useNavigate();

  return (
    <div className="th-section">
      <div className="th-section__category">
        <div className="th-section__container">
          <span className="th-hero__text th-hero__text__title th-hero__text__sub">
            Involve Without Worry, We
            <span className="th-hero__text__subtitle">
              {" "}
              Handle the Hosting!
            </span>
          </span>
          <span className="th-hero__subtext th-hero__subtext__title">
            Host stress-free events with loved ones—seamless planning at an
            affordable price.
          </span>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <div className="th-section__category__container">
            <div
              className="th-section__category__item"
              onClick={() => navigate("/service/ai-enabled-event-details")}
            >
              <div
                className="th-event__category__svg"
                style={{
                  borderRadius: "8px",
                  background: "#E9F7FC",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M21.2754 4V7.94903"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.582 4V7.94903"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M27.2253 16.6986V11.4652C27.2357 7.85738 25.0459 5.89325 21.5107 5.89325H11.3501C7.82525 5.89325 5.625 7.85738 5.625 11.4652V22.3251C5.625 25.99 7.82525 27.9982 11.3501 27.9982H16.708"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.7607 13.2008H22.0889"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.9799 26.6376L21.851 26.2887C21.3647 24.9725 20.3286 23.9349 19.0145 23.448L18.666 23.3188L19.0145 23.1897C20.3286 22.7027 21.3647 21.6651 21.851 20.3491L21.9799 20L22.1089 20.3491C22.5952 21.6651 23.6313 22.7027 24.9454 23.1897L25.294 23.3188L24.9454 23.448C23.6313 23.9349 22.5952 24.9725 22.1089 26.2887L21.9799 26.6376Z"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M28.7611 28.2235C28.5419 27.5025 27.9786 26.9383 27.2588 26.7188C27.9786 26.4995 28.5419 25.9352 28.7611 25.2143C28.9802 25.9352 29.5435 26.4995 30.2634 26.7188C29.5435 26.9383 28.9802 27.5025 28.7611 28.2235Z"
                    stroke="#26B8E3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-column gap-1">
                <span className="th-plan__text th-line__height">
                  AI enabled event details
                </span>
                <span className="th-event__subtext">
                  Know what to do exactly (AI enabled)
                </span>
              </div>
            </div>
            <div
              className="th-section__category__item"
              onClick={() => navigate("/service/invite")}
            >
              <div
                className="th-event__category__svg"
                style={{
                  borderRadius: "8px",
                  background: "#FFF5F4",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="32"
                  viewBox="0 0 33 32"
                  fill="none"
                >
                  <path
                    d="M21.6084 4V7.94903"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.915 4V7.94903"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M27.5583 16.6986V11.4652C27.5687 7.85738 25.3789 5.89325 21.8437 5.89325H11.6831C8.15826 5.89325 5.95801 7.85738 5.95801 11.4652V22.3251C5.95801 25.99 8.15826 27.9982 11.6831 27.9982H17.041"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.0938 13.2008H22.4219"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22.313 26.6376L22.184 26.2887C21.6977 24.9725 20.6617 23.9349 19.3475 23.448L18.999 23.3188L19.3475 23.1897C20.6617 22.7027 21.6977 21.6651 22.184 20.3491L22.313 20L22.4419 20.3491C22.9282 21.6651 23.9643 22.7027 25.2784 23.1897L25.627 23.3188L25.2784 23.448C23.9643 23.9349 22.9282 24.9725 22.4419 26.2887L22.313 26.6376Z"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M29.0941 28.2235C28.8749 27.5025 28.3116 26.9383 27.5918 26.7188C28.3116 26.4995 28.8749 25.9352 29.0941 25.2143C29.3132 25.9352 29.8765 26.4995 30.5964 26.7188C29.8765 26.9383 29.3132 27.5025 29.0941 28.2235Z"
                    stroke="#F7735B"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-column gap-1">
                <span className="th-plan__text th-line__height">
                  Send Invitation
                </span>
                <span className="th-event__subtext">
                  Invite and manage your guests
                </span>
              </div>
            </div>
            <div
              className="th-section__category__item"
              onClick={() => navigate("/service/hire-a-priest")}
            >
              <div
                className="th-event__category__svg"
                style={{
                  borderRadius: "8px",
                  background: "#FBF7F4",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M9.42769 27.3344C7.40233 27.3344 6.17844 26.0202 6.0918 24.1898C6.0918 20.464 10.1245 19.1788 16.2005 19.1354C22.2876 19.1932 26.3311 20.4784 26.3093 24.1898C26.2119 26.0202 24.9952 27.3344 22.9735 27.3344H9.42769Z"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M16.2111 14.8837C19.0324 14.8837 21.3196 12.5966 21.3196 9.7752C21.3196 6.95383 19.0324 4.66666 16.2111 4.66666C13.3898 4.66666 11.1025 6.95383 11.1025 9.7752C11.1025 12.5966 13.3898 14.8837 16.2111 14.8837Z"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                </svg>
              </div>
              <div className="flex flex-column gap-1">
                <span className="th-plan__text th-line__height">
                  Book a Priest
                </span>
                <span className="th-event__subtext">
                  Book a expert priest from multiple list
                </span>
              </div>
            </div>
          </div>
          <div className="th-section__category__container">
            <div
              className="th-section__category__item"
              onClick={() => navigate("/service/rental-services-for-events")}
            >
              <div
                className="th-event__category__svg"
                style={{
                  borderRadius: "8px",
                  background: "#FBF7F4",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M21.8877 4V8.29768"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.4561 4V8.29768"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.6541 5.98175L10.7022 5.98294C7.19148 5.98294 5 7.93795 5 11.5314V22.3492C5 25.9994 7.19148 27.9997 10.7022 27.9997L22.6438 27.9985C26.1649 27.9985 28.346 26.0332 28.346 22.4385V11.5302C28.3564 7.93676 26.1752 5.98175 22.6541 5.98175Z"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.275 12.73L18.2684 14.7175C18.367 14.9131 18.5563 15.0482 18.7728 15.0796L20.9984 15.399C21.359 15.4468 21.6131 15.7787 21.5651 16.1383C21.5456 16.2859 21.477 16.4235 21.3692 16.527L19.7598 18.0728C19.603 18.2242 19.529 18.4424 19.5666 18.6582L19.9479 20.8412C20.0062 21.2047 19.7586 21.5479 19.394 21.6071C19.2502 21.63 19.1036 21.606 18.9752 21.5378L16.9883 20.5068C16.7924 20.4059 16.5591 20.4059 16.3632 20.5068L14.375 21.5378C14.0495 21.7107 13.6436 21.5871 13.4711 21.2614C13.4036 21.1327 13.379 20.9851 13.4023 20.8412L13.7823 18.6582C13.8212 18.4438 13.7487 18.2242 13.5904 18.0728L11.9796 16.527C11.719 16.2746 11.7099 15.8582 11.9615 15.5956C12.0652 15.4884 12.2027 15.4191 12.3505 15.4002L14.576 15.0796C14.7939 15.0494 14.982 14.9143 15.0806 14.7187L16.0766 12.73C16.2491 12.3994 16.655 12.2708 16.9858 12.4411C17.109 12.5054 17.2102 12.6064 17.275 12.73Z"
                    stroke="#C7905C"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-column gap-1">
                <span className="th-plan__text th-line__height">
                  Rent from tent houses
                </span>
                <span className="th-event__subtext">
                  Select and book tables, chairs, plates, tents etc from vendors
                </span>
              </div>
            </div>
            <div
              className="th-section__category__item"
              onClick={() => navigate("/service/book-catering")}
            >
              <div
                className="th-event__category__svg"
                style={{
                  borderRadius: "8px",
                  background: "#F0F6F1",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M26.8409 23.2292L26.4816 24.4072C26.0833 25.7148 24.8768 26.6087 23.5108 26.6087H8.49064C7.12459 26.6087 5.91809 25.7148 5.51983 24.4072L5.16047 23.2292M4 23.2292H28"
                    stroke="#006C19"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.5507 6.94156C17.5507 6.08535 16.8567 5.3913 16.0005 5.3913C15.1442 5.3913 14.4502 6.08535 14.4502 6.94156C14.4502 7.79778 15.1446 8.49138 16.0007 8.49138C16.857 8.49138 17.5507 7.79778 17.5507 6.94156Z"
                    stroke="#006C19"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.33879 19.6975C5.03393 13.6015 9.8949 8.49152 15.9987 8.49152C22.1025 8.49152 26.9634 13.6015 26.6598 19.6975"
                    stroke="#006C19"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex flex-column gap-1">
                <span className="th-plan__text th-line__height">
                  Order catering
                </span>
                <span className="th-event__subtext">
                  Book best of the caterers from multiple list
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThurentServices;
